module.exports = __webpack_public_path__ + "static/media/vi.9e8216a3.svg";